import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=3b038c96&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=3b038c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b038c96",
  null
  
)

export default component.exports